import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import {
  childApplyListSelector,
  isEnableLoadingChildApplySelector,
} from '../selector';
import { getChildApplyList } from '../thunk';

import Add from './Add';

import type { UserAttributes } from '@/infra/cognitoIApi';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';

import AdditionalLoading from '@/components/AdditionalLoading';
import ChildApplyInfo from '@/domain/childApply/component/ChildApplyInfo';
import { toStringDateTimeDisplay } from '@/utils/date';

/** プロパティ */
export type Props = {
  /** 子ども */
  child: ChildJson,
  /** ユーザー名 */
  username: string,
  /** 属性 */
  attrs: UserAttributes,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const Apply: React.FC<Props> = ({
  child,
  username,
  attrs,
  facilityList,
}) => {
  const dispatch = useDispatch();
  // const parent = convertToChildApplyParent(username, attrs);
  const childApplyList = useSelector(childApplyListSelector);
  const isEnableLoading = useSelector(isEnableLoadingChildApplySelector);
  const cont = [];
  for (let i = 0; i < childApplyList.length; i += 1) {
    const {
      facilityName,
      childFamilyName,
      childName,
      applyDateTime,
    } = childApplyList[i].data;
    const status = childApplyList[i].pub?.data.applyStatus || '-';
    const dateString = toStringDateTimeDisplay(new Date(applyDateTime));
    const id = `[${facilityName} (${status})] ${childFamilyName} ${childName} (申請日時: ${dateString})`;
    cont.push((
      <Accordion key={i}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          {id}
        </AccordionSummary>
        <AccordionDetails>
          <ChildApplyInfo key={id} data={childApplyList[i]} />
        </AccordionDetails>
      </Accordion>
    ));
  }
  return (
    <div>
      <Add
        child={child}
        username={username}
        attrs={attrs}
        facilityList={facilityList}
      />
      {cont}
      {cont.length === 0 && <div style={{ marginTop: '10px' }}>申請がありません。</div>}
      {cont.length > 0 && (
        <AdditionalLoading
          isEnableLoading={isEnableLoading}
          onClick={() => dispatch(getChildApplyList())}
        />
      )}
    </div>
  );
};

export default Apply;
